<template>
	<b-modal
		id="isInform-list"
        v-model=modalOpen
		:title="contents.subject"
		ok-only
        no-close-on-backdrop
		ok-title="Close"
		:size="modalSize"
        centered
	>
        <div v-if="Object.keys(contents).length > 0">
            <section
                class="border-none mt-3 mb-3 ql-container ql-snow"
            >
                <template v-if="Object.keys(contents).includes('paragraphs')">
                    <template v-for="(item, itemIdx) in contents.paragraphs">
                        <div v-if="item.type=='p'" :key="itemIdx">
                            <div v-html="item.content"></div>
                        </div>
                        <div v-if="item.type=='img' && item.src!=''" :key="itemIdx">
                            <img :src="item.src" :style="{'width': item.width + 'px'}">
                        </div>
                    </template>
                </template>
                <template v-if="Object.keys(contents).includes('contents')">
                    <div
                        class="ql-editor"
                        v-html="contents.contents"
                    >
                    </div>
                </template>
            </section>
        </div>
        <div v-else class="d-flex justify-content-center py-2">
            <b-spinner style="width: 1.5rem; height: 1.5rem;"/>
        </div>
        <template #modal-footer>
            <div class="w-100">
                <b-form-checkbox
                v-model="selected"
                :value="contents.timestamp"
                class="custom-control-primary float-left mt-25"
                >
                    {{ $t('org.message.Do not open for a day') }}
                </b-form-checkbox>
                <b-button
                    variant="primary"
                    size="sm"
                    class="float-right"
                    @click="modalClose(contents.timestamp)"
                >
                    Close
                </b-button>
            </div>
        </template>
	</b-modal>
</template>

<script>
import { getCurrentInstance, ref, computed, watch } from '@vue/composition-api'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        document: {
            type: Object,
            default () {
                return {}
            }
        },
        list: {
            type: Array,
            default () {
                return []
            }
        },
        modalSize: {
            type: String,
            default: 'lg'
        }
    },
    setup (props) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        const isInformList = props.document
        const modalOpen = ref(true)
        const selected = ref(false)
        const contents = ref({})

        const boardDocument = computed(() => store.getters.boardDocument)

        const modalClose = (timeStamp) => {
            if (selected.value) {
                localStorage.setItem('isInform-hide' + timeStamp, Date.now())
            }
            modalOpen.value = false
        }

        store.dispatch('getBoardDocument', { timestamp: isInformList.timestamp, service: isInformList.service })
        watch(boardDocument, (value) => {
            contents.value = value
        })
        return {
            isInformList,
            modalOpen,
            selected,
            contents,
            boardDocument,
            modalClose
        }
    }
}
</script>
<style scoped>
    .border-none {
        border: none !important;
    }
    .background-transparent {
        background-color: transparent !important;
    }
    .box-shadow-none {
        box-shadow: none
    }

</style>
